import {
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  AUTH_ERROR,
  USER_LOADED,
  GET_ALL_USERS,
  LOGOUT,
} from "../actions/types";

const initialState = {
  user: null,
  users: [],
  isAuthenticated: false,
  loading: true,
  token: localStorage.getItem("token"),
};

export default function userReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case USER_LOADED:
      return {
        ...state,
        user: payload,
        loading: false,
        isAuthenticated: true,
      };
    case REGISTER_SUCCESS:
      localStorage.setItem("token", payload.data.token);
      return {
        ...state,
        user: payload.data.user,
        loading: false,
        isAuthenticated: true,
      };
    case LOGIN_SUCCESS:
      localStorage.setItem("token", payload.data.token);
      return {
        ...state,
        user: payload.data.user,
        loading: false,
        isAuthenticated: true,
      };
    case REGISTER_FAILED:
    case LOGIN_FAILED:
    case LOGOUT:
    case AUTH_ERROR:
      localStorage.removeItem("token");
      return {
        ...state,
        user: null,
        loading: false,
        isAuthenticated: false,
      };
    case GET_ALL_USERS:
      return {
        ...state,
        loading: false,
        users: payload,
      };
    default:
      return state;
  }
}
